import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

const PaymentCancel = () => {
  return (
    <main className="min-h-screen bg-charcoal flex items-center justify-center px-6 py-24">
      <div className="max-w-2xl w-full text-center">
        <XCircle size={48} className="text-off-white/70 mx-auto mb-6" strokeWidth={1.5} />
        <p className="font-mono text-[10px] tracking-[0.3em] text-rose mb-3">// CHECKOUT CANCELED</p>
        <h1 className="font-serif-display italic text-4xl md:text-6xl text-off-white leading-[0.95]">
          No worries —<br />your cart is saved.
        </h1>
        <p className="mt-6 text-off-white/70 font-light max-w-lg mx-auto">
          You weren't charged. Pick up right where you left off whenever you're ready.
        </p>
        <div className="mt-10 flex flex-wrap gap-3 justify-center">
          <Link
            to="/shop"
            className="btn-blueprint inline-flex items-center h-12 px-7 bg-rose text-charcoal font-mono text-[11px] tracking-[0.25em] font-semibold hover:bg-off-white transition-colors-only"
          >
            RETURN TO SHOP
          </Link>
          <Link
            to="/"
            className="inline-flex items-center h-12 px-7 border border-off-white/30 text-off-white font-mono text-[11px] tracking-[0.25em] hover:border-rose hover:text-rose transition-colors-only"
          >
            HOME
          </Link>
        </div>
      </div>
    </main>
  );
};

export default PaymentCancel;
